// extracted by mini-css-extract-plugin
export var banner = "_e7-0";
export var closeButton = "_e7-2";
export var greenCheckmark = "_e7-3";
export var hereLink = "_e7-4";
export var titleIcon = "_e7-1";